(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moda-growth"]) return;
  try {
    
(()=>{const dialog=document.getElementById('moda-newsletter');if(!dialog)return;const key='moda-newsletter-last-shown';let shown=false,ready=false;const open=()=>{if(dialog.open)return;dialog.showModal();shown=true;try{localStorage.setItem(key,String(Date.now()))}catch(e){}};document.querySelectorAll('[data-moda-open]').forEach(b=>b.addEventListener('click',open));dialog.querySelector('[data-moda-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});if(dialog.querySelector('[data-moda-success],[data-moda-error]')){open();return}let suppressed=false;try{suppressed=Date.now()-Number(localStorage.getItem(key)||0)<7*86400000}catch(e){}if(suppressed||window.Shopify?.designMode)return;const maybe=()=>{const height=document.documentElement.scrollHeight-innerHeight;if(ready&&!shown&&height>0&&scrollY/height>=.25&&document.visibilityState==='visible'){open();window.removeEventListener('scroll',maybe)}};setTimeout(()=>{ready=true;maybe()},10000);window.addEventListener('scroll',maybe,{passive:true})})();

  } catch(e) { console.error(e); }
})();
})();
